import Vue from 'vue'

export function feishuSdkInit() {
  // 加载飞书sdk-js
  const s = document.createElement('script')
  s.type = 'text/javascript'
  s.src = 'https://s3.bytecdn.cn/ee/lark/js_sdk/h5-js-sdk-1.4.13.js'
  const feishuElement = document.body.appendChild(s)
  feishuElement.onload = () => {
    // console.log(window.h5sdk)
  }
}

// 飞书扫码
export function feishuScanQRCode(callback) {
  window.h5sdk.ready(function () {
    window.h5sdk.biz.util.scan({
      type: ['qrCode', 'barCode'],
      onSuccess: function (res) {
        var result = res.text
        callback({
          result
        })
      },
      onFail: function(error) {
        callback()
      }
    })
  })
}

// 飞书定位
export function feishuGetLocation(showMessage, callback) {
  window.h5sdk.ready(function () {
    window.h5sdk.device.geolocation.get({
      useCache: false,
      type: 'gcj02',
      onSuccess: function(locationData) {
        // console.log(123)
        // console.log('success1', locationData)
        var lat = locationData.latitude // 纬度，浮点数，范围为90 ~ -90
        var lng = locationData.longitude // 经度，浮点数，范围为180 ~ -180。
        callback({
          lat,
          lng
        })
      },
      onFail: function(errorMsg) {
        if (showMessage) {
          Vue.prototype.$message({
            type: 'error',
            message: `飞书定位失败，请稍后重试`
          })
        }
        callback()
        console.log('error', errorMsg)
      }
    })
  })
}
